import styled from 'styled-components'

export const ChipInput = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;
  z-index: 0;
  width: 1px;
  height: 1px;
`
